import { h, VNode } from 'preact';
import { MonthKey, MONTHS, WeekdayKey, WEEKDAYS } from '../../common/calendar';
import { pad } from '../../utils';
import { dateI18n, DateI18n, IntlContextWithDictionary } from '../types';

export enum DateFormat {
  FULL_DETAILED = 'fullDetailed',
  FULL = 'full',
  DATE = 'date',
  MONTH_AND_YEAR = 'monthAndYear',
  DATE_AND_MONTH_FULL = 'dateAndMonthFull',
  DATE_AND_MONTH = 'dateAndMonth',
  YEAR = 'yyyy',
  MONTH = 'MMMM',
  MONTH_SHORT = 'MMM',
  VOICE_OVER_DATE = 'EE, d MMMM',
  WEEKDAY = 'EE',
  WEEKDAY_SHORT = 'E',
  ISO_8601 = 'yyyy-MM-dd',
}

type Extractor = (d: Date, translations?: DateI18n) => string;
const yyyy = (date: Date): string => String(date.getUTCFullYear());
const yy = (date: Date): string => yyyy(date).slice(-2);
const M = (date: Date): string => String(date.getUTCMonth() + 1);
const MM = (date: Date): string => pad(M(date));
const MMM = (date: Date, { monthsShort }: DateI18n): string => {
  const month: MonthKey = MONTHS[date.getUTCMonth()];
  return monthsShort[month];
};
const MMMM = (date: Date, { months }: DateI18n): string => {
  const month: MonthKey = MONTHS[date.getUTCMonth()];
  return months[month];
};
const d = (date: Date): string => String(date.getUTCDate());
const dd = (date: Date): string => pad(d(date));
const E = (date: Date, { weekdaysShort }: DateI18n): string => {
  const weekday: WeekdayKey = WEEKDAYS[date.getUTCDay()];
  return weekdaysShort[weekday];
};
const EE = (date: Date, { weekdays }: DateI18n): string => {
  const weekday: WeekdayKey = WEEKDAYS[date.getUTCDay()];
  return weekdays[weekday];
};

const MATCHER = /yy(?:yy)?|M{1,4}|d{1,2}|E{1,2}/g;
const REPLACEMENTS: { [part: string]: Extractor } = { yy, yyyy, M, MM, MMM, MMMM, d, dd, E, EE };

export const dateFormat = (value: string, format: DateFormat, context?: IntlContextWithDictionary): string => {
  const i18n: DateI18n = dateI18n(context);
  const date: Date = new Date(value);
  const pattern: string = i18n.formats[format] || format;

  return pattern.replace(MATCHER, (m) => {
    return REPLACEMENTS[m] ? REPLACEMENTS[m](date, i18n) : m;
  });
};

export const marked = (title: string, text: string): VNode<any> => {
  return h(
    'mark',
    {
      style: 'background: rgba(119,231,117,.5)',
      title,
    },
    text
  );
};
